import { mapMutationsFromTypes } from 'schepotin-vuex-helpers';
import * as types from './mutation-types';
import emitResize from '../../../utils/emitResize';

export default {
    /**
     * Generates {@link https://vuex.vuejs.org/en/mutations.html | mutations} from
     * {@link https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types | mutation types}
     *
     * Documentation
     * {@link https://www.npmjs.com/package/schepotin-vuex-helpers#mapmutationsfromtypes | mapMutationsFromTypes}
     */
    ...mapMutationsFromTypes({
        types,
        excludes: [
            types.CLOSE_ALL,
            types.CLOSE_RIGHT,
            types.CLOSE_CENTER,
            types.NOTIFICATION_TOAST,
        ],
    }),
    [types.CLOSE_ALL](state) {
        state.signInForm = false;
        state.signUpForm = false;
        state.recoverPasswordForm = false;
        state.resetPasswordForm = false;
        state.profileForm = false;
        state.settingsForm = false;
        state.selectPictureForm = false;
        state.notificationsList = false;
    },
    [types.CLOSE_CENTER](state) {
        state.settingsForm = false;
        state.selectPictureForm = false;
    },
    [types.CLOSE_RIGHT](state) {
        state.signInForm = false;
        state.signUpForm = false;
        state.recoverPasswordForm = false;
        state.resetPasswordForm = false;
        state.profileForm = false;
        state.notificationsList = false;
    },
    [types.NOTIFICATION_TOAST](state, payload) {
        state.notificationToast.visible = payload.visible;
        state.notificationToast.id = payload.id;
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/navbar/mutations.js